import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/create/customer.create.matches.query.gql"
import type {
  CustomerCreateMatchesQuery,
  CustomerCreateMatchesQueryVariables,
} from "@/v2-backoffice-client/customer/create/__types__/customer.create.matches.query"

type Options = QueryHookOptions<
  CustomerCreateMatchesQuery,
  CustomerCreateMatchesQueryVariables
>

export function useCustomerCreateMatchesQuery(options?: Options) {
  return useQuery<
    CustomerCreateMatchesQuery,
    CustomerCreateMatchesQueryVariables
  >(query, options)
}
